import { redirect } from "@tanstack/react-router"

import { getViewerFn } from "@/lib/app.functions"

export async function requireMemberRoute(next: string) {
  const viewer = await getViewerFn()
  if (!viewer) {
    throw redirect({ to: "/login", search: { next } })
  }
  return viewer
}

export async function requireAdminRoute(next: string) {
  const viewer = await requireMemberRoute(next)
  if (viewer.role !== "admin") {
    throw redirect({ to: "/dashboard" })
  }
  return viewer
}
